<template>
    <div id="modal-delivery-address">
        <div class="modal-trigger" @click='openDeliveryAddressModal'>
            <slot></slot>
        </div>

        <!-- Modal -->
        <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId + 'Label'"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="modalId + 'Label'">Lieferadresse hinzufügen</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            Hier können Sie eine von der Rechnungsadresse abweichende Lieferadresse angeben.
                        </p>

                        <div class="row justify-content-center align-items-top">
                            <div class="col-12">
                                <div class="container-fluid">
                                    <h4 class="register-h4 mb-4">Ihre Rechnungsanschrift</h4>

                                    <div class="form-row">
                                        <div class="col-12 col-sm-10 col-lg-8 form-group">
                                            <label for="fields_first_name">Name</label>
                                            <input required type="text" name="deliveryAddress[contact_person]"
                                                   id="fields_first_name"
                                                   dusk="first_name"
                                                   class="form-control"
                                                   :class="getValidationClass(fields.name.valid)"
                                                   placeholder="Ansprechpartner"
                                                   @change="validateName"
                                                   v-model="fields.name.value">
                                            <div class="invalid-feedback">
                                                @{{ fields.name.error }}
                                            </div>
                                        </div>
                                        <div class="col-11 col-sm-10 col-lg-4 form-group">
                                            <label for="fields_company">
                                                Firmenname
                                                <small>(optional)</small>
                                            </label>
                                            <input type="text" name="deliveryAddress[company]"
                                                   id="fields_company"
                                                   dusk="company"
                                                   placeholder="Firma"
                                                   @change="validateCompanyName"
                                                   class="form-control"
                                                   :class="getValidationClass(fields.company_name.valid)"
                                                   v-model="fields.company_name.value">
                                            <div class="invalid-feedback">
                                                @{{ fields.company_name.error }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12 col-sm-12 col-lg-7 form-group mb-0">
                                            <label for="fields_street">Strasse und Hausnummer</label>
                                            <input required type="text"
                                                   dusk="street"
                                                   id="fields_street"
                                                   class="form-control"
                                                   name="deliveryAddress[street]"
                                                   :class="getValidationClass(fields.street.valid)"
                                                   placeholder="Strasse + Hausnummer"
                                                   @change="validateStreet"
                                                   v-model="fields.street.value">
                                            <div class="invalid-feedback">
                                                @{{ fields.street.error }}
                                            </div>
                                        </div>
                                    </div>

                                    <!--
                                    <div class="form-row">
                                        <div id="addressBlock" class="col-12 col-lg-7">
                                            <address-line
                                                    v-on:newAddressLine="addAddressLine"
                                                    :given-lines="fields.addressLines.values"
                                                    field-name="deliveryAddress[additional]"
                                                    v-on:removeAddressLine="removeAddressLine"
                                            ></address-line>
                                        </div>
                                    </div>
                                    -->

                                    <div class="form-row mt-2">
                                        <div class="col-5 col-sm-4 col-lg-2 form-group">
                                            <label for="fields_postal_code">Postleitzahl</label>
                                            <input required type="text" name="deliveryAddress[postal_code]"
                                                   dusk="plz"
                                                   id="fields_postal_code"
                                                   class="form-control"
                                                   :class="getValidationClass(fields.postalCode.valid)"
                                                   placeholder="PLZ"
                                                   @change="validatePostalCode"
                                                   v-model="fields.postalCode.value">
                                            <div class="invalid-feedback">
                                                @{{ fields.postalCode.error }}
                                            </div>
                                        </div>
                                        <div class="col-7 col-sm-8 col-lg-5 form-group">
                                            <label for="fields_city">Ort</label>
                                            <input required type="text" name="deliveryAddress[city]" id="fields_city"
                                                   dusk="city"
                                                   class="form-control"
                                                   :class="getValidationClass(fields.city.valid)"
                                                   placeholder="Ort / Stadt"
                                                   @change="validateCity"
                                                   v-model="fields.city.value">
                                            <div class="invalid-feedback">
                                                @{{ fields.city.error }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row mt-2">
                                        <div class="col-11 col-sm-6 col-lg-4 form-group">
                                            <input type="hidden" name="country" v-model="fields.country.value"
                                                   class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>
                        <button type="button" class="btn btn-primary" @click="submitDeliveryAddress" v-if="formValid">
                            Lieferadresse speichern
                        </button>
                        <button type="button" class="btn btn-primary disabled" v-else>Lieferadresse speichern</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PNotify from 'pnotify/dist/es/PNotify';

PNotify.defaults.styling = 'bootstrap4';
PNotify.defaults.icons = 'fontawesome5';

    export default {
        name: "ModalDeliveryAddress",
        props: {
          country: {
            type: String,
            default: "Deutschland"
          },
            trigger: {
                type: String,
                required: false,
                default: ""
            },
            modalId: {
                type: String,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            },
            consumer: {
                type: Object,
                required: false,
                default: null
            }
        },
        data() {
            return {
                fields: {
                    name: {
                        value: "",
                        valid: 0,
                        error: "Bitte richtig ausfüllen",
                        success: ""
                    },
                    company_name: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    street: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    postalCode: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    city: {
                        value: "",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    addressLines: {
                        values: [],
                        valid: 0,
                        error: "",
                        success: ""
                    },
                    country: {
                        value: "DE",
                        valid: 0,
                        error: "",
                        success: ""
                    },
                },
            }
        },
        computed: {
          addressCountry() {
            switch(this.address.country) {
              case "DE":
                return "Deutschland"
              case "CH":
                return "Schweiz"
              case "AT":
                return "Österreich";
            }
          },
            formValid() {
                let total = 0;
                this.fields.name.valid === 1 ? total += 1 : total += 0;
                this.fields.street.valid === 1 ? total += 1 : total += 0;
                this.fields.postalCode.valid === 1 ? total += 1 : total += 0;
                this.fields.city.valid === 1 ? total += 1 : total += 0;

                return total === 4;
            },
            consumerObject(){
                if(this.consumer != null){
                    return this.consumer;
                } else {
                    return this.subscription.details.consumer;
                }
            }
        },
        methods: {
            openDeliveryAddressModal: function () {
                $('#' + this.modalId).modal('show');
            },
            closeDeliveryAddressModal: function () {
                $('#' + this.modalId).modal('hide');
            },
            submitDeliveryAddress: function () {
                let deliveryAddress = {
                    contact_person: this.fields.name.value,
                    company: this.fields.company_name.value,
                    street: this.fields.street.value,
                    postal_code: this.fields.postalCode.value,
                    city: this.fields.city.value,
                    //additional: this.fields.addressLines.values,
                    country: 'germany'
                };

                let self = this;

                if(this.subscription.delivery_address !== null){
                    axios.patch('/api/checkout/' + this.subscription.id + '/update-addresses', {
                        identifier: this.subscription.identifier,
                        address_data: deliveryAddress,
                        addressType: 'delivery',
                        subscription: this.subscription.id,
                        consumer: this.consumer.id
                    }).then(r => {
                        if (r.status === 202) {
                            PNotify.info(r.data.message);
                        } else {
                            PNotify.success(r.data.message);
                        }
                        self.$emit('delivery-address-updated');
                        //self.recalculateDeliveryCosts();
                        self.closeDeliveryAddressModal();
                        location.reload();
                    }).catch(e => {
                        PNotify.error({
                            title: "Fehlerhafte Adresse",
                            text: "Die eingegebene Adresse scheint fehlerhaft zu sein. Bitte übeerprüfe deine Angaben."
                        });
                    })
                } else {
                    let subscriptionDetails = this.subscription.details;
                    subscriptionDetails['deliveryAddress'] = deliveryAddress;

                    axios.patch('/api/checkout/' + this.subscription.id, {
                        identifier: this.subscription.identifier,
                        subscription: {
                            details: subscriptionDetails
                        }
                    }).then(r => {
                        PNotify.success("Lieferadresse wurde hinzugefügt!");
                        //self.recalculateDeliveryCosts();
                        self.closeDeliveryAddressModal();
                        self.$emit('delivery-address-updated');
                        location.reload();
                    }).catch(e => {
                        self.closeDeliveryAddressModal();
                        PNotify.error("Leider ist ein Fehler aufgetreten. Versuche es später erneut oder wende dich an unseren Support!");
                    });
                }
            },
            recalculateDeliveryCosts(){
                var self = this;
                axios.get('/api/checkout/' + this.subscription.id + '/delivery-costs', {
                    params: {
                        identifier: this.subscription.identifier,
                    }
                }).then(result =>  {
                    self.$emit('new-delivery-costs-calculated', result.data.costs);
                    PNotify.info("Neue Lieferkosten wurden berechnet!");
                    location.reload();
                }).catch(e => {
                    console.warn(e);
                });
            },
            validateName() {
                let name = this.fields.name.value;
                if (name.length > 0) {
                    let re = /^[A-Za-z\u00C0-\u017F\s\-\.]+$/;
                    let valid = re.test(name);
                    this.fields.name.valid = valid ? 1 : -1;
                } else {
                    this.fields.name.valid = 0;
                }
            },
            validateCompanyName() {
                let company_name = this.fields.company_name.value;
                if(company_name != null) {
                    if (company_name.length > 0) {
                        this.fields.company_name.valid = 1;
                        return;
                    }
                }
                this.fields.company_name.valid = 0;
            },
            validateStreet() {
                let street = this.fields.street.value;
                if (street.length > 0) {
                    let re = /^\d+$/;
                    let invalid = re.test(street); // Contains numbers only
                    this.fields.street.valid = invalid ? -1 : 1;
                } else {
                    this.fields.street.valid = 0;
                }
            },
            validatePostalCode() {
                let plz = this.fields.postalCode.value;
                if (plz.length === 0) {
                    this.fields.postalCode.valid = 0;
                } else if (plz.length > 5) {
                    this.fields.postalCode.valid = -1;
                } else {
                    let re = /\b\d{4,5}(?:-\d{4})?\b/;
                    let valid = re.test(plz);
                    this.fields.postalCode.valid = valid ? 1 : -1;
                }
            },
            validateCity() {
                let city = this.fields.city.value;
                if (city.length > 0) {
                    let re = /^[A-Za-z\u00C0-\u017F ]+$/;
                    let valid = re.test(city);
                    this.fields.city.valid = valid ? 1 : -1;
                } else {
                    this.fields.city.valid = 0;
                }
            },
            getValidationClass(valid) {
                // valid could be -1,0,1
                let className = '';
                switch (valid) {
                    case -1:
                        className = 'is-invalid';
                        break;
                    case 1:
                        className = 'is-valid';
                        break;
                    default:
                        className = '';
                        break;
                }
                return className;
            },
            addAddressLine: function (payload) {
                this.fields.addressLines.values[payload.id] = payload.value;
            },
            removeAddressLine: function (payload) {
                this.fields.addressLines.values.splice(payload, 1);
            },
        },
        mounted(){
            let address;

            if(this.subscription.delivery_address !== null){
                address = this.subscription.delivery_address;
            } else {
                address = this.subscription.details.deliveryAddress;
            }

            this.fields.name.value = address.contact_person ?
                address.contact_person :
                this.consumerObject.first_name + " " + this.consumerObject.last_name;
            this.fields.company_name.value = address.company;
            this.fields.street.value = address.street;
            this.fields.postalCode.value = address.postal_code;
            this.fields.city.value = address.city;
            this.fields.country.value = address.country;
            //this.fields.addressLines.values = details.deliveryAddress.additional;

            this.validateName();
            this.validateCompanyName();
            this.validateStreet();
            this.validatePostalCode();
            this.validateCity();
        }
    }
</script>

<style scoped lang="scss">
    .modal-trigger {
        cursor: pointer;
    }
</style>
